import { render } from "./FlowElementTest.vue?vue&type=template&id=3868fea5&scoped=true"
import script from "./FlowElementTest.vue?vue&type=script&lang=js"
export * from "./FlowElementTest.vue?vue&type=script&lang=js"

import "./FlowElementTest.vue?vue&type=style&index=0&id=3868fea5&scoped=true&lang=css"

import exportComponent from "../../../peelochat-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3868fea5"]])

export default __exports__